import { withStyles } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { PaginationItem } from "reactstrap";

export const StyledPagination = withStyles((theme) => ({
  ul: {
    justifyContent: "center",
  },
}))(Pagination);

export const StyledPaginationItem = withStyles((theme) => ({
  root: {
    border: 0,
    backgroundColor: "#757575",
    color: "#595858",
  },
  selected: {
    border: 0,
    backgroundColor: "#2196F3",
    color: "#ffffff",
  },
}))(PaginationItem);
